<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">资金明细</div>
      <div class="search-wrap">
        <div class="search-form">
          <div class="search-item search-input-item search-box">
            <input type="text" class="search-input"  v-model="searchForm.amountMix" placeholder="提现金额"/>
            <span>至</span>
            <input type="text" class="search-input"  v-model="searchForm.amountMax" placeholder="提现金额"/>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.createStartTime" @blur.native @focus="showDatePicker('createStartTime')" placeholder="提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createStartTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createStartTime')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.createEndTime" @blur.native @focus="showDatePicker('createEndTime')" placeholder="提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createEndTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createEndTime')">
            </el-col>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.doneStartTime" @blur.native @focus="showDatePicker('doneStartTime')" placeholder="处理提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.doneStartTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.doneStartTime')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.doneEndTime" @blur.native @focus="showDatePicker('doneEndTime')" placeholder="处理提现时间" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.doneEndTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.doneEndTime')">
            </el-col>
          </div>
        </div>
        <div class="search-btn" @click="handleFilter">查询</div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-0-15 padding-b-8">
      <div class="title-text-official padding-11-0 padding-b-19">列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="序号" width="50" align="center">
            <template slot-scope="{row}">
              <span>{{ row.sequence }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="真实姓名" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.receiveRealName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="支付宝账号" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.receiveAccount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现金额" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.withdrawal }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="实际打款金额" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.actualWithdrawal }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.createTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="打款时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.doneTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="提现状态" width="80" align="center">
            <template slot-scope="{ row }">
              <span>{{getStateText(row.status)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.pageNo" :limit.sync="searchForm.pageSize" @pagination="getList(false)" />
      </div>
    </div>
    <DatePicker ref="DatePicker" :title="curDateTitle" @selectedDate="selectedDate"></DatePicker>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import DatePicker from '@/components/h5/DatePicker'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import { getDate } from '@/utils/date'
import withdraw from '@/javaApi/withdraw.js'
const withdrawModel = new withdraw()
export default {
  name: 'Member',
  components: {
    DatePicker,
    Pagination
  },
  data: function () {
    return {
      listLoading: false,
      list:[],
      total:0,
      platformUuid:getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        id: undefined,
        amountMix:undefined,
        amountMax:undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        doneEndTime:undefined,
        doneStartTime:undefined
      },
      curDateTitle: '',// 日期选择器弹窗标题
      datePicker: '', // 用于判断哪个选择器
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false){
      let that = this
      this.listLoading = true
      if(first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.createStartTime = getDate(searchForm.createStartTime)
      if(searchForm.createStartTime){
        searchForm.createStartTime = searchForm.createStartTime+' 00:00:00'
      }else{
        delete  searchForm.createStartTime
      }

      searchForm.createEndTime = getDate(searchForm.createEndTime)

      if(searchForm.createEndTime){
        searchForm.createEndTime = searchForm.createEndTime+' 23:59:59'
      }else{
        delete  searchForm.createEndTime
      }

      searchForm.doneStartTime = getDate(searchForm.doneStartTime)
      if(searchForm.doneStartTime){
        searchForm.doneStartTime = searchForm.doneStartTime+' 00:00:00'
      }else{
        delete  searchForm.doneStartTime
      }
      searchForm.doneEndTime = getDate(searchForm.doneEndTime)
      if(searchForm.doneEndTime){
        searchForm.doneEndTime = searchForm.doneEndTime+' 23:59:59'
      }else{
        delete  searchForm.doneEndTime
      }
      if(!searchForm.withdrawMix){
        delete  searchForm.withdrawMix
      }
      if(!searchForm.withdrawMax){
        delete  searchForm.withdrawMax
      }
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        searchForm.platformUuid =  this.platformUuid
      }
      searchForm = this.formateInit(searchForm)
      withdrawModel.getWithdrawList(searchForm).then(response=>{
        that.listLoading = false
        let res = response.data
        if(res.code == 200){
          if(res.data){
            this.list = res.data.list?res.data.list:[]
            this.list = this.formateData(this.list)
            this.total =  res.data.total?res.data.total:0
          }
        }else{
          let message = res.message?res.message:'系统异常,请稍后再试！'
          that.$Message.error(message)
        }
      }).catch(error=>{
        console.log(error)
        that.listLoading = false
        if(error != 'token invalid'){
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    formateData(data){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    getStateText(state){
      // 提现状态：1 待处理，2 提现成功，3 提现失败，4 微信打款失败(二次触发提现不改订单)
      let text = ''
      switch (parseInt(state)){
        case 1:
          text = '待处理'
          break;
        case 2:
          text = '提现成功'
          break;
        case 3:
          text = '提现失败'
          break;
        case 4:
          text='微信打款失败'
          break;
        default:
          text = '暂时没有状态'
      }
      return text
    },
    handleFilter(){
      this.getList(true)
    },
    changePage(value){
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value){
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchForm.pageNo == 1){
        this.getList()
      }
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    showDatePicker(datePicker){
      let title = '请选择开始日期';
      if(datePicker.toUpperCase().indexOf('END') > -1){
        title = '请选择结束日期';
      }
      this.curDateTitle = title
      this.datePicker = datePicker
      this.$refs.DatePicker.init();
    },
    selectedDate(timer){
      this.searchForm[this.datePicker] = timer;
    },
    //清除文本框
    clear(val) {
      if(val.indexOf(".") > -1){
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      }else{
        this[val] = ''
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .table-wrapper {
    width: 100%;
    .color-ff4{
      white-space: nowrap;
      line-height: 1.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/withdraw/Index.vue